import dayjs from '@/utils/dayjs.config';
import { BRReal } from './masks';

export const formatUTCDate = (date: Date): string => {
  if (Object.prototype.toString.call(date) === '[object Date]' && isNaN(date.getTime())) return formatUTCDate(new Date());
  // if(Object.prototype.toString.call(date) === "[object Date]" && isNaN(date.getTime()))
  //   return formatUTCDate(new Date());

  if (typeof date === 'string') return date;

  if (date instanceof Date)
    return `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date
      .getUTCDate()
      .toString()
      .padStart(2, '0')}`;

  return '';
};

export const formatUTCDatetime = (date: Date): string => {
  if (Object.prototype.toString.call(date) === '[object Date]' && isNaN(date.getTime())) return formatUTCDatetime(new Date());

  if (typeof date === 'string') return date;

  if (date instanceof Date)
    return `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date
      .getUTCDate()
      .toString()
      .padStart(2, '0')}`;

  return '';
};

export const formatDate = (date: Date): string => {
  if (Object.prototype.toString.call(date) === '[object Date]' && isNaN(date.getTime())) return formatDate(new Date());

  if (typeof date === 'string') return date;

  if (date instanceof Date)
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${date.getFullYear()}`;

  return '';
};

export const formatTime = (date: Date): string => {
  if (Object.prototype.toString.call(date) === '[object Date]' && isNaN(date.getTime())) return formatTime(new Date());

  if (typeof date === 'string') return date;

  if (date instanceof Date)
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
      .getSeconds()
      .toString()
      .padStart(2, '0')}`;

  return '';
};

export const formatDatetime = (date: Date): string => {
  if (Object.prototype.toString.call(date) === '[object Date]' && isNaN(date.getTime())) return formatDatetime(new Date());

  if (typeof date === 'string') return date;

  if (date instanceof Date)
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date
      .getMinutes()
      .toString()
      .padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

  return '';
};

export function formatCurrency(value: number) {
  return BRReal.format((value || 0) / 100);
}

export function formatDateS(value: string, format = 'DD/MM/YYYY HH:mm') {
  if (!value) return '';
  const date = dayjs(value, 'YYYY-MM-DDTHH:mm:ss.SSS');
  if (!date.isValid) return value;
  return date.format(format);
}

export function nowDate(format = 'DD/MM/YYYY HH:mm') {
  const date = dayjs();
  return date.format(format);
}

export function formatPhoneNumber(phoneNumber: string) {
  // return phoneNumber.replace(/\D+/g, '').replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

  const cleanedValue = phoneNumber.replace(/\D/g, ''); // remove caracteres não numéricos

  if (cleanedValue.length === 8 || cleanedValue.length === 9) {
    // Celular sem DDD com 8 ou 9 dígitos
    return cleanedValue.replace(/(\d{4,5})(\d{4})/, '$1-$2');
  }

  if (cleanedValue.length === 10 || cleanedValue.length === 11) {
    // Celular com DDD com 8 ou 9 dígitos
    return cleanedValue.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
  }

  if (cleanedValue.length === 12 || cleanedValue.length === 13) {
    // Celular com código de país e DDD com 8 ou 9 dígitos
    return cleanedValue.replace(/(\d{2})(\d{2})(\d{4,5})(\d{4})/, '+$1 ($2) $3-$4');
  }

  return cleanedValue;
}

export function formatPercent(value: any) {
  value = String(value);
  if (typeof value !== 'string') return String(value);
  value = value.replace('.', '').replace(',', '').replace(/\D/g, '');
  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(value) / 100);
  return '% ' + result;
}

export const formatCpfCnpj = (value: string) => {
  const cleanedValue = value.replace(/\D/g, ''); // remove caracteres não numéricos

  if (cleanedValue.length <= 11) {
    // CPF
    return cleanedValue
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  } else {
    // CNPJ
    return cleanedValue
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }
};

export const formatCep = (value: string) => {
  const cleanedValue = value.replace(/\D/g, ''); // remove caracteres não numéricos

  return cleanedValue.replace(/(\d{5})(\d)/, '$1-$2');
};
